ACC.placeorder = {

  bindAll: function() {
    this.bindPlaceOrd();
    this.updatePlaceOrderButton();
    this.uplodDocCheckBox();
    this.uploadButton();
  },
  bindPlaceOrd: function() {
    $('#Terms1').click(function() {
      var termsoneenable = $('#Terms1').attr('checked');

      /* eslint-disable  no-undefined */
      if (termsoneenable === undefined || termsoneenable === 'false') {
        /* eslint-enable  no-undefined */
        $('#Terms2').attr('checked', false);
      } else {
        $('#Terms2').attr('checked', true);
      }
    });

    $('#Terms2').click(function() {
      var termstwoenable = $('#Terms2').attr('checked');

      /* eslint-disable  no-undefined */
      if (termstwoenable === undefined || termstwoenable === 'false') {
        /* eslint-enable  no-undefined */
        $('#Terms1').attr('checked', false);
      } else {
        $('#Terms1').attr('checked', true);
      }
    });
    $('#lumifyAddendum1').click(function() {
      var lumifyAddendumone = $('#lumifyAddendum1').attr('checked');

      /* eslint-disable  no-undefined */
      if (lumifyAddendumone === undefined || lumifyAddendumone === 'false') {
        /* eslint-enable  no-undefined */
        $('#lumifyAddendum2').attr('checked', false);
      } else {
        $('#lumifyAddendum2').attr('checked', true);
      }
    });

    $('#lumifyAddendum2').click(function() {
      var lumifyAddendumtwo = $('#lumifyAddendum2').attr('checked');

      /* eslint-disable  no-undefined */
      if (lumifyAddendumtwo === undefined || lumifyAddendumtwo === 'false') {
        /* eslint-enable  no-undefined */
        $('#lumifyAddendum1').attr('checked', false);
      } else {
        $('#lumifyAddendum1').attr('checked', true);
      }
    });

    $('#aedAddendum').click(function() {
      var aedid = '#aedAddendum';
      var aedAddendumone = $(String(aedid)).attr('checked');

      /* eslint-disable  no-undefined */
      if (aedAddendumone === undefined || aedAddendumone === 'false') {
        /* eslint-enable  no-undefined */
        $(String(aedid)).attr('checked', false);
      } else {
        $(String(aedid)).attr('checked', true);
      }
    });
  },

  uplodDocCheckBox: function() {
    if ($('#vatExclusionFlag').prop('checked')) {
      $('.fileToUploadHolder').slideDown('slow');
    } else {
      $('.fileToUploadHolder').slideUp('slow');
    }

    $('#vatExclusionFlag').click(function() {
      var checkedStatus = 'false';

      if ($('#vatExclusionFlag').prop('checked')) {
        checkedStatus = 'true';
        $('.fileToUploadHolder').slideDown('slow');
      } else {
        checkedStatus = 'false';
        $('#fileToUpload').val('');
        $('.fileToUploadHolder').slideUp('slow');
        $('#formateErrorMessage,#uploadSucessMsg').hide();
      }

      $.postJSON('/checkout/single/summary/setVatExclusionFlag.json', {
        vatExclusionFlag: checkedStatus
      });
    });
  },
  uplodDocButton: function(obj) {
    $('#formateErrorMessage,#uploadSucessMsg').hide();

    if ((/(\.pdf|\.png|\.gif|\.jpg|\.jpeg)$/i).test($(obj.fId).val())) {
      $.ajax({
        url: obj.path,
        type: 'post',
        data: obj.formData,
        contentType: false,
        processData: false,
        enctype: 'multipart/form-data',
        success: function() {
          $('#uploadSucessMsg').show();
        }
      });
    } else {
      $('#formateErrorMessage').show();
      $(obj.fId).val('');
      $(obj.fId).focus();

      if (obj.resetMsg) {
        $('.ph-filebrowsetext').html(obj.resetMsg);
      }
    }
  },

  uploadButton: function() {
    $('#uploadVatFile').click(function() {
      var obj = {};

      obj.formData = new FormData(document.getElementById('placeOrderForm1'));
      obj.path = '/payment/summary/VATExclusionCertificateUpload.json';
      obj.fId = '#fileToUpload';
      ACC.placeorder.uplodDocButton(obj);
    });
  },

  updatePlaceOrderButton: function() {
    var deliveryAddress = $('#checkout_summary_deliveryaddress_div').hasClass('complete');
    var deliveryMode = $('#checkout_summary_deliverymode_div').hasClass('complete');
    var costCenter = $('#checkout_summary_costcenter_div').hasClass('complete');
    var billingAddress = $('#checkout_summary_billing_div').hasClass('complete');
    var paymentDetails = $('#checkout_summary_payment_div').hasClass('complete');

    if ($('#PaymentTypeSelection_ACCOUNT').prop('checked') && deliveryAddress && deliveryMode) {
      if (costCenter || billingAddress || paymentDetails) {
        $('.place-order').removeAttr('disabled');
      } else {
        $('.ph-checkoutpayment').css('order', '1');
        $('.place-order').attr('disabled', true);
      }
    } else {
      $('.ph-checkoutpayment').css('order', '1');
      $('.place-order').attr('disabled', true);
    }
  },

  placeOrderWithSecurityCode: function(formnr) {
    var securityCode = $('#SecurityCode' + formnr).val();

    $('.securityCodeClass').val(securityCode);
    ACC.placeorder.trackPlaceOrderWithCTN();
    $('.place-order').attr('disabled', true);
    document.getElementById('placeOrderForm1').submit();
  },

  trackPlaceOrderWithCTN: function() {
    if ($('#Terms1').attr('checked')) {
      var ctnArr = [];

      $('#cart_items_tbody tr').each(function() {
        ctnArr.push($(this).attr('data-productcode'));
      });

      if (ctnArr.length > 0) {
        ACC.omniture.bindTrackConversion('buy_at_philips', ctnArr.toString());
      }
    }
  }
};

$(document).ready(function() {
  ACC.placeorder.bindAll();
});

